import { FC, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { ChatMessageList } from './chat-message-list';
import { ChatWelcomeMessage } from './chat-welcome-message';

interface ChatBodyNamespace extends FC<PropsWithChildren> {
  ChatMessageList: typeof ChatMessageList;
  ChatWelcomeMessage: typeof ChatWelcomeMessage;
}

export const ChatBody: ChatBodyNamespace = ({ children }) => {
  return <div css={styles.container}>{children}</div>;
};

ChatBody.ChatMessageList = ChatMessageList;
ChatBody.ChatWelcomeMessage = ChatWelcomeMessage;

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    flex: 1;
    padding: ${theme.spacing(1, 0)};
  `,
};
